import Swiper, { Navigation, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';

export default class {
    init() {
        const sliders = document.querySelectorAll('.swiper-container');
        if (sliders.length === 0) {
            return;
        }

        sliders.forEach(this.activateSlider);
    }

    activateSlider(slider) {
        if (slider.dataset.hasNavigation) {
            Swiper.use([Navigation]);
        }

        if (slider.dataset.autoplay) {
            Swiper.use([Autoplay]);
        }

        const swiper = new Swiper(slider, {
            direction: 'horizontal',
            grabCursor: true,
            loop: slider.dataset?.loop || false,

            spaceBetween: 32,
            slidesPerView: 1,
            centeredSlides: slider.dataset?.centerView || false,
            autoplay: !!slider.dataset.autoplay ? {
                delay: 3000
            } : false,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: slider.dataset?.slidesPerView || 1
                }
            },

            navigation: slider.dataset?.hasNavigation? {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            } : false,
        })

        if (slider.dataset.autoplay) {
            swiper.autoplay.start();
        }
    }
}
